import store from "../store/index";
import routerMap, {entityRouter, homeRouter} from "./router";
import {getStorageInfo} from "../common/js/storage";
import {clone} from "../common/js/tool";

/**
 * 角色权限配置
 * @type {{role_${role}: [{action: [], id: string}]}}
 */
const activityModule = {
    id: 'activity',
    action: ['query'],
    routes: [
        'activityList',
        'createActivity',
        'activity',
        'activityInfo',
        'activityDetail',
        'activityGroup',
        'activityDecorate',
        'activityStaff',
        'activityHomePreview',
        'activitySchedule',
        'activityArticle',
        'activityVideo',
        'activityGuest',
        'activityGuestVerify',
        'activityGuestInfo',
        'activityLocation',
        'activityEnroll',
        'activityMealAssign',
        'activityMealInfo',
        'activityMeal',
        'activityFoodOrder',
        'activityFoodType',
        'activityFoodTime',
        'activityFoodSet',
        'activityStayAssign',
        'activityStayInfo',
        'activityHotel',
        'activityRoom',
        'activityGiftAssign',
        'activityGift',
        'activityVehicleAssign',
        'activityTravelInfo',
        'activityJourney',
        'activityDriver',
        'activityVehicle',
        'activityPass',
        'activityDeliveryList',
        'activityDeliveryCar',
        'activityDeliveryDetail',
        'activityDeliverySet',
        'activityReceptionist',
        'activityMeetingRoom',
    ]
};

const defaultConfig = {
    module: [
        clone(activityModule)
    ],
    menus: [
        {
            title: '活动管理',
            path: '/activity',
            icon: require("../assets/icon/activity.png"),
        },
    ]
}

// 超管权限
const adminConfig = clone(activityModule);
adminConfig.action = ['add', 'delete', 'update', 'query', 'audit'];

const rolePermissionConfig = {
    role_1: {
        module: [
            clone(adminConfig),
            {
                id: 'guest',
                action: ['add', 'delete', 'update', 'query', 'audit'],
                routes: ['guest']
            },
            {
                id: 'template',
                action: ['add', 'delete', 'update', 'query', 'audit'],
                routes: ['template', 'templateDecorate']
            },
            {
                id: 'scene',
                action: ['add', 'delete', 'update', 'query', 'audit'],
                routes: ['scene']
            },
            {
                id: 'icon',
                action: ['add', 'delete', 'update', 'query', 'audit'],
                routes: ['icon']
            },
            {
                id: 'insider',
                action: ['add', 'delete', 'update', 'query', 'audit'],
                routes: ['insider']
            },
            {
                id: 'admin',
                action: ['add', 'delete', 'update', 'query', 'audit'],
                routes: ['admin']
            },
            {
                id: 'inviteGuest',
                action: ['add', 'delete', 'update', 'query', 'audit'],
                routes: ['inviteGuest']
            },
            {
                id: 'zdMeeting',
                action: ['add', 'delete', 'update', 'query', 'audit'],
                routes: ['zdMeeting']
            },
        ],
        menus: [
            {
                title: '活动管理',
                path: '/activity',
                icon: require("../assets/icon/activity.png"),
            },
            {
                title: '场景管理',
                path: '/scene',
                icon: require("../assets/icon/scene.png"),
            },
            {
                title: '嘉宾图库',
                path: '/entity/guest',
                icon: require("../assets/icon/guest.png"),
            },
            // {
            //     title: '模板管理',
            //     path: '/template',
            //     icon: require("../assets/icon/template.png"),
            // },
            {
                title: '图标管理',
                path: '/icon',
                icon: require("../assets/icon/icon.png"),
            },
            {
                title: '内部人员管理',
                path: '/insider',
                icon: require("../assets/icon/guest.png"),
            },
            {
                title: '权限管理',
                path: '/admin',
                icon: require("../assets/icon/auth.png"),
            },
            {
                title: '其他活动',
                path: '/extra',
                icon: require("../assets/icon/activity.png"),
                children: [
                    {
                        title: '中东电商峰会',
                        path: '/extra/zddsfh',
                    }
                ]
            },
        ]
    },
    role_2: clone(defaultConfig),
    role_3: clone(defaultConfig),
    role_4: clone(defaultConfig),
    role_5: clone(defaultConfig),
}

export const generateRouter = function (user) {
    let info = user || getStorageInfo();
    let role = info.type * 1;
    let conf = rolePermissionConfig[`role_${role}`];
    if(conf) {
        let menus = conf.menus;
        let routerList = [homeRouter];
        let routers = [], entity = {};
        conf.module.forEach(item => {
            const id = item.id;
            const routes = item.routes;
            routes.forEach(r => {
                let router = routerMap[r];
                // 装修页面路由放在Home外面
                if(r == 'templateDecorate' || r == 'activityDecorate') {
                    routerList.push({...router.router});
                } else {
                    // 检测是否采用的是公用实体路由
                    if(router.entity) {
                        entity[id] = item.action;
                    } else if(router.parent) {
                        const pr = routerMap[router.parent];
                        pr.router.children.push(router.router);
                    } else {
                        // 不是公共实体路由则将其加进路由
                        if(router.router) {
                            // 将操作权限放入路由的meta里
                            if(router.router.meta) {
                                router.router.meta.action = item.action
                            } else {
                                router.router.meta = {
                                    action: item.action
                                }
                            }
                            routers.push(router.router);
                        }
                    }
                }
            });
        });
        // 默认将menu第一个作为默认路由
        let temp = menus[0];
        if(temp.children && temp.children.length > 0) {
            temp = temp.children[0].path
        } else {
            temp = temp.path;
        }
        let keys = Object.keys(entity);
        if(keys.length > 0) {
            let r = clone(entityRouter);
            r.meta.action = entity;
            routers.push(r);
        }
        homeRouter.children = homeRouter.children.concat(routers);
        store.commit("setMenus", menus);
        store.commit("setDefaultPath", temp);
        return {routers: routerList, defaultPath: temp};
    } else {
        return null;
    }
}
